// Channel base keys
export const CHANNEL_CACHE_KEY = "CHANNEL";
export const CHANNEL_CACHE_KEYS = {
  all: [CHANNEL_CACHE_KEY] as const,
  list: () => [...CHANNEL_CACHE_KEYS.all, "LIST"] as const,
  detail: (channelId: string) =>
    [...CHANNEL_CACHE_KEYS.all, "DETAIL", channelId] as const,
};

// Social Posts keys
export const SOCIAL_POSTS_CACHE_KEY = "SOCIAL_POSTS";
export const SOCIAL_POSTS_CACHE_KEYS = {
  all: [SOCIAL_POSTS_CACHE_KEY] as const,
  list: (
    channelId: string,
    q?: string,
    mediaProductTypes?: string[],
    ids?: string[],
  ) =>
    [
      ...SOCIAL_POSTS_CACHE_KEYS.all,
      "LIST",
      channelId,
      q ?? "",
      mediaProductTypes?.join(",") ?? "",
      ids?.join(",") ?? "",
    ] as const,
  channel: (channelId: string) =>
    [...SOCIAL_POSTS_CACHE_KEYS.all, "LIST", channelId] as const,
};

// Welcome Message keys (unified for Instagram & Messenger)
export const WELCOME_MESSAGE_CACHE_KEY = "WELCOME_MESSAGE";
export const WELCOME_MESSAGE_CACHE_KEYS = {
  all: [WELCOME_MESSAGE_CACHE_KEY] as const,
  list: (channelId: string) =>
    [...WELCOME_MESSAGE_CACHE_KEYS.all, "LIST", channelId] as const,
  detail: (channelId: string, messageId: string) =>
    [
      ...WELCOME_MESSAGE_CACHE_KEYS.all,
      "DETAIL",
      channelId,
      messageId,
    ] as const,
};

// Persistent Menu keys (unified for Instagram & Messenger)
export const PERSISTENT_MENU_CACHE_KEY = "PERSISTENT_MENU";
export const PERSISTENT_MENU_CACHE_KEYS = {
  all: [PERSISTENT_MENU_CACHE_KEY] as const,
  detail: (channelId: string) =>
    [...PERSISTENT_MENU_CACHE_KEYS.all, "DETAIL", channelId] as const,
};

// WhatsApp Template keys
export const WHATSAPP_TEMPLATE_CACHE_KEY = "WHATSAPP_TEMPLATE";
export const WHATSAPP_TEMPLATE_CACHE_KEYS = {
  all: [WHATSAPP_TEMPLATE_CACHE_KEY] as const,
  list: (channelId: string) =>
    [...WHATSAPP_TEMPLATE_CACHE_KEYS.all, "LIST", channelId] as const,
  detail: (channelId: string, templateId: string) =>
    [
      ...WHATSAPP_TEMPLATE_CACHE_KEYS.all,
      "DETAIL",
      channelId,
      templateId,
    ] as const,
  sync: (channelId: string) =>
    [...WHATSAPP_TEMPLATE_CACHE_KEYS.all, "SYNC", channelId] as const,
};
